import { Bus } from '@/js/helpers/event-bus'
import log from 'loglevel'
import { i18n } from '@/i18n'
import { ErrorTracker } from '@/js/helpers/error-tracker'
import { errors } from '@/js/errors'

export class ErrorHandler {
  static process (error, translationId = '', errorTrackerConfig = {}) {
    const msgTrId = translationId || ErrorHandler._getTranslationId(error)
    Bus.error(msgTrId)

    errorTrackerConfig.translationId = msgTrId
    ErrorHandler.processWithoutFeedback(error, errorTrackerConfig)
  }

  static processWithoutFeedback (error, errorTrackerConfig = {}) {
    ErrorHandler.trackMessage(error, errorTrackerConfig)
    log.error(error)
  }

  static trackMessage (error, opts = {}) {
    const { translationId = '', skipTrack = false } = opts

    if (!skipTrack) {
      const msgTrId = translationId || ErrorHandler._getTranslationId(error)

      const englify = i18n.getFixedT('en')
      ErrorTracker.trackMessage(englify(msgTrId))
    }
  }

  static _getTranslationId (error) {
    let translationId

    switch (error.constructor) {
      case errors.InternalServerError:
        translationId = 'errors.internal'
        break
      case errors.BadRequestError:
        translationId = 'errors.bad-request'
        break
      case errors.NotAllowedError:
        translationId = 'errors.not-allowed'
        break
      case errors.ForbiddenRequestError:
        translationId = 'errors.forbidden'
        break
      case errors.NotFoundError:
        translationId = 'errors.not-found'
        break
      case errors.ConflictError:
        translationId = 'errors.conflict'
        break
      default:
        translationId = 'errors.default'
    }

    return translationId
  }
}
